<ng-container
  *ngIf="{
    lineItems: (lineItems$ | async),
    isNonPartnerAutomation: (isNonPartnerAutomation$ | async),
    lineItemsInvalid: (lineItemsInvalid$ | async)
  } as data"
>
  <ng-container>
    <div class="content">
      <div class="description subtitle">
        {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.SUBTITLE' | translate }}
      </div>

      <ng-container *ngIf="!data.isNonPartnerAutomation">
        <div class="description title">
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.SELECT_PRODUCTS_TITLE' | translate }}
        </div>
        <ng-container *ngIf="(loading$ | async) === false; else loading"></ng-container>
        <EXP__glxy-wrap>
          <sales-ui-sales-order-confirmation
            #salesOrderConfirmation
            [ngClass]="{ error: data.lineItemsInvalid }"
            [hidden]="loading$ | async"
            [partnerId]="automation.namespace"
            [marketId]="marketId"
            [lineItems]="data.lineItems"
            [removeHeader]="true"
            [editable]="true"
            [startEditing]="true"
            [hidePackages]="hidePackages"
            (loading)="updateLoading($event)"
          ></sales-ui-sales-order-confirmation>
        </EXP__glxy-wrap>
      </ng-container>

      <ng-container *ngIf="!data.isNonPartnerAutomation; else templateSubtitle">
        <div class="description title additional-info">
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.ADDITIONAL_INFO_TITLE' | translate }}
        </div>
      </ng-container>
      <ng-template #templateSubtitle>
        <div class="description title additional-info">
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.OPTIONAL_INFO_TITLE' | translate }}
        </div>
      </ng-template>
      <div class="control-container">
        <glxy-form-field [required]="!data.isNonPartnerAutomation">
          <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.NAME' | translate }}</glxy-label>
          <input matInput [formControl]="opportunityNameControl" [required]="!data.isNonPartnerAutomation" />
          <mat-error *ngIf="opportunityNameControl.hasError('required') && !!opportunityNameControl.dirty">
            {{ 'COMMON.THIS_FIELD_REQUIRED' | translate }}
          </mat-error>
        </glxy-form-field>
        <automata-salesperson-selector
          [formControl]="assigneeFormControl"
          [partnerId]="automation.namespace"
          [marketId]="automation.marketId"
        ></automata-salesperson-selector>
        <ng-container *ngIf="!data.isNonPartnerAutomation">
          <automata-pipeline-selector
            #pipelineSelector
            [required]="!data.isNonPartnerAutomation"
            [selectedPipelineId]="initialPipelineId"
            [selectedStageId]="initialStageId"
            (loaded)="pipelineSelectorLoaded()"
          ></automata-pipeline-selector>
        </ng-container>
        <glxy-form-field [required]="!data.isNonPartnerAutomation">
          <glxy-label>
            {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.EXPECTED_CLOSE_DATE_TITLE' | translate }}
          </glxy-label>
          <input
            matInput
            [formControl]="expectedCloseNumDaysControl"
            [required]="!data.isNonPartnerAutomation"
            type="number"
          />
          <mat-error *ngIf="expectedCloseNumDaysControl.hasError('required') && !!expectedCloseNumDaysControl.dirty">
            {{ 'COMMON.THIS_FIELD_REQUIRED' | translate }}
          </mat-error>
          <mat-error *ngIf="expectedCloseNumDaysControl.hasError('pattern') && !!expectedCloseNumDaysControl.dirty">
            {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.VALIDATION.POSITIVE_OR_ZERO' | translate }}
          </mat-error>
        </glxy-form-field>
      </div>

      <glxy-form-field>
        <glxy-label>
          {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.TYPE' | translate }}
        </glxy-label>
        <mat-select [formControl]="opportunityTypeFormControl">
          <mat-option *ngFor="let option of opportunityTypeOptions" [value]="option.value">
            {{ option.label | translate }}
          </mat-option>
        </mat-select>
      </glxy-form-field>

      <div class="description title">
        {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.EXPECTED_DURATION_TITLE' | translate }}
      </div>
      <span class="date">
        <glxy-form-field>
          <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.LENGTH' | translate }}</glxy-label>
          <input matInput [formControl]="durationValueControl" type="number" />
          <mat-error *ngIf="durationValueControl.hasError('pattern') && !!durationValueControl.dirty">
            {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.VALIDATION.POSITIVE' | translate }}
          </mat-error>
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>
            {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.PERIOD' | translate }}
          </glxy-label>
          <mat-select [formControl]="durationTimeFrameControl">
            <mat-option *ngFor="let option of durationOptions" [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          </mat-select>
        </glxy-form-field>
      </span>
      <span class="disclaimer">
        {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.EXPECTED_DURATION_DISCLAIMER' | translate }}
      </span>
    </div>
  </ng-container>
</ng-container>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container">
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
    <span class="control-container selector stencil-shimmer"></span>
  </div>
</ng-template>
